// extracted by mini-css-extract-plugin
export default {"main_box":"item-details_main_box__vzc-N","container":"item-details_container__R6KUK","gallery":"item-details_gallery__jzQgG"};